<template>
  <div class="app-container">
    <!-- 顶部工具栏：左侧筛选条件，右侧实时统计 -->
    <div class="page-toolbar">
      <el-form class="filter-form" :inline="true" @keyup.enter.native="toFilter">
        <el-form-item label="资产码">
          <el-input placeholder="请输入资产码" v-model="filter.assets_code" clearable></el-input>
        </el-form-item>
        <el-form-item label="设备类型">
          <el-select class="selScale" v-model="filter.dev_type">
            <el-option label="--全部--" value=""> </el-option>
            <el-option label="插座" value="power_charge_cz"> </el-option>
            <el-option label="充电桩" value="power_charge_pile"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select class="selScale" v-model="filter.online">
            <el-option label="--全部--" value=""> </el-option>
            <el-option label="在线" value="1"> </el-option>
            <el-option label="离线" value="0"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        </el-form-item>
      </el-form>

      <!-- 统计数据 -->
      <div class="stat-group">
        <div class="stat-card">
          <div class="stat-icon stat-icon-power"><i class="el-icon-odometer"></i></div>
          <div class="stat-info">
            <span class="stat-label">总功率</span>
            <span class="stat-value">{{ totalPowerText }}<span class="stat-unit">kW</span></span>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon stat-icon-charging"><i class="el-icon-lightning"></i></div>
          <div class="stat-info">
            <span class="stat-label">充电中</span>
            <span class="stat-value">{{ chargingPileText }}<span class="stat-unit">枪</span></span>
          </div>
        </div>
      </div>
    </div>

    <el-card class="box-card">
      <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
        <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
        <el-table-column label="资产码" prop="asset_code" width="220" align="center">
          <template slot-scope="{ row }">
            <div class="show_assets_code" @click="showTripletDetail(row.asset_code)">{{ row.asset_code }}</div>
          </template>
        </el-table-column>

        <el-table-column label="设备名称" prop="re_dev_name" align="center" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="设备类型" prop="re_dev_type" align="center" width="100px"></el-table-column>

        <el-table-column label="状态" prop="status_name" align="center" width="80">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.status == 1">在线</el-tag>
            <el-tag type="info" v-else>离线</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="功率(kW)" prop="cur_power" width="100" align="center"></el-table-column>
        <el-table-column label="协议类型" prop="asset_code" width="90" align="center">
          <template slot-scope="{ row }">
            {{ row.dev_type == 1 ? "云快充" : "国网" }}
          </template>
        </el-table-column>
        <el-table-column label="在线时间" prop="last_time" width="190" align="center"></el-table-column>
        <el-table-column label="投运时间" prop="create_time" width="190" align="center"></el-table-column>
        <el-table-column :label="$t('publics.operation')" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
            <el-button type="text" v-if="row.status == 1" @click="onDevRestart(row)" v-permision_tjtf="'dev_restart'">设备重启</el-button>
            <el-button type="text" @click="editPowerCurve(row)" v-permision_tjtf="'gl_quxian'">功率曲线</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 设备状态详情弹窗 -->
    <el-dialog :visible.sync="detailVisible" title="设备状态详情" width="1300px" :close-on-click-modal="false" class="detail-dialog lower_formitem_box">
      <el-row type="flex" justify="center">
        <el-col :span="24">
          <el-form label-position="right" label-width="120px" :model="detailForm" ref="detailForm" style="padding: 0px 30px">
            <!-- 1. 档案信息（triplet） -->
            <h3>档案信息</h3>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="资产码" prop="assetsCode">
                  <el-input v-model="detailForm.triplet.assetsCode" readonly disabled />
                </el-form-item>
                <el-form-item label="出厂编码" prop="FactoryCode">
                  <el-input v-model="detailForm.triplet.FactoryCode" readonly disabled />
                </el-form-item>

                <el-form-item label="公钥" prop="PublickKey">
                  <el-input v-model="detailForm.triplet.PublickKey" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="私钥" prop="SecrtKey">
                  <el-input v-model="detailForm.triplet.SecrtKey" readonly disabled />
                </el-form-item>
                <el-form-item label="注册码" prop="RegCode">
                  <el-input v-model="detailForm.triplet.RegCode" readonly disabled />
                </el-form-item>
                <el-form-item label="类型名称" prop="TypeName">
                  <el-input v-model="detailForm.triplet.TypeName" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态" prop="State">
                  <el-input v-model="detailForm.triplet.State" readonly disabled />
                </el-form-item>
                <el-form-item label="创建时间" prop="CreateTime">
                  <el-input v-model="detailForm.triplet.CreateTime" readonly disabled />
                </el-form-item>
                <el-form-item label="" prop="triplet_id">
                  <el-button type="primary" v-permision_tjtf="'send_query_sim'" @click="onSendQuerySim(detailForm)"> 查询sim</el-button>
                  <!-- <el-button type="primary" v-permision_tjtf="'call_offline_order'" v-if="detailForm.status == 1" @click="onCallOfflineOrder(detailForm)">招离线订单</el-button> -->
                  <el-button type="primary" v-if="detailForm.dev_type == 1" @click="onTimeSync(detailForm)">YCK对时</el-button>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 2. 设备信号强度数据（acDeRealIty） -->
            <h3>信号强度</h3>
            <el-row :gutter="20" v-if="detailForm.acDeRealIty">
              <el-col :span="8">
                <el-form-item label="机箱温度" prop="caseTemp">
                  <el-input v-model="detailForm.acDeRealIty.caseTemp" readonly disabled />
                </el-form-item>

                <el-form-item label="网络ID" prop="netId">
                  <el-input v-model="detailForm.acDeRealIty.netId" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="网络类型" prop="netType">
                  <el-input :value="formatNetType(detailForm.acDeRealIty.netType)" readonly disabled />
                </el-form-item>
                <el-form-item label="loraMac" prop="netId">
                  <el-input v-model="detailForm.acDeRealIty.loraMac" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="信号值" prop="sigVal">
                  <el-input v-model="detailForm.acDeRealIty.sigVal" readonly disabled />
                </el-form-item>
                <el-form-item label="loraRssi" prop="netId">
                  <el-input v-model="detailForm.acDeRealIty.loraRssi" readonly disabled />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-else>
              <el-col :span="24"><div class="zanwu">--暂无--</div></el-col>
            </el-row>

            <!-- 3. 设备版本信息（verinfo_evt） -->
            <h3>设备版本</h3>
            <el-row :gutter="20" v-if="detailForm.verinfo_evt">
              <el-col :span="12">
                <el-form-item label="SDK版本" prop="sdkVer">
                  <el-input v-model="detailForm.verinfo_evt.sdkVer" readonly disabled />
                </el-form-item>
                <el-form-item label="设备注册方式" prop="devRegMethod">
                  <el-input :value="formatDevRegMethod(detailForm.verinfo_evt.devRegMethod)" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="硬件版本" prop="pileHardwareVer">
                  <el-input v-model="detailForm.verinfo_evt.pileHardwareVer" readonly disabled />
                </el-form-item>
                <el-form-item label="软件版本" prop="pileSoftwareVer">
                  <el-input v-model="detailForm.verinfo_evt.pileSoftwareVer" readonly disabled />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-else>
              <el-col :span="24"><div class="zanwu">--暂无--</div></el-col>
            </el-row>
            <!-- 4. 设备固件信息（firmware_evt） -->
            <h3>设备固件</h3>
            <el-row :gutter="20" v-if="detailForm.firmware_evt">
              <el-col :span="8">
                <el-form-item label="CT" prop="firmware_evt_CT">
                  <el-input v-model="detailForm.firmware_evt.CT" readonly disabled />
                </el-form-item>
                <el-form-item label="计量类型" prop="meaType">
                  <el-input v-model="detailForm.firmware_evt.meaType" readonly disabled />
                </el-form-item>
                <el-form-item label="蓝牙MAC" prop="btMac">
                  <el-input v-model="detailForm.firmware_evt.btMac" readonly disabled />
                </el-form-item>
                <el-form-item label="设备序列号" prop="devSn">
                  <el-input v-model="detailForm.firmware_evt.devSn" readonly disabled />
                </el-form-item>
                <el-form-item label="设备类型" prop="devType">
                  <el-input v-model="detailForm.firmware_evt.devType" readonly disabled />
                </el-form-item>

                <el-form-item label="电网类型" prop="gridType">
                  <el-input v-model="detailForm.firmware_evt.gridType" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="输出电流" prop="otCur">
                  <el-input v-model="detailForm.firmware_evt.otCur" readonly disabled />
                </el-form-item>
                <el-form-item label="最大输出电压" prop="otMaxVol">
                  <el-input v-model="detailForm.firmware_evt.otMaxVol" readonly disabled />
                </el-form-item>
                <el-form-item label="最小输出电压" prop="otMinVol">
                  <el-input v-model="detailForm.firmware_evt.otMinVol" readonly disabled />
                </el-form-item>
                <el-form-item label="输出功率" prop="otRate">
                  <el-input v-model="detailForm.firmware_evt.otRate" readonly disabled />
                </el-form-item>
                <el-form-item label="端口数量" prop="portNum">
                  <el-input v-model="detailForm.firmware_evt.portNum" readonly disabled />
                </el-form-item>
                <el-form-item label="SIM卡MAC" prop="simMac">
                  <el-input v-model="detailForm.firmware_evt.simMac" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="电表地址" prop="outMeter_db">
                  <el-input v-model="detailForm.firmware_evt.outMeter_db" readonly disabled />
                </el-form-item>
                <el-form-item label="门锁状态" prop="isGateLock">
                  <el-input :value="formatGateLockStatus(detailForm.firmware_evt.isGateLock)" readonly disabled />
                </el-form-item>
                <el-form-item label="地锁状态" prop="isGroundLock">
                  <el-input :value="formatGroundLockStatus(detailForm.firmware_evt.isGroundLock)" readonly disabled />
                </el-form-item>
                <el-form-item label="SIM卡号" prop="simNo">
                  <el-input v-model="detailForm.firmware_evt.simNo" readonly disabled />
                </el-form-item>
                <el-form-item label="桩型号" prop="stakeModel">
                  <el-input v-model="detailForm.firmware_evt.stakeModel" readonly disabled />
                </el-form-item>
                <el-form-item label="厂商代码" prop="vendorCode">
                  <el-input v-model="detailForm.firmware_evt.vendorCode" readonly disabled />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-else>
              <el-col :span="24"><div class="zanwu">--暂无--</div></el-col>
            </el-row>
            <!-- 5. 设备类型信息 -->
            <h3>设备类型信息</h3>
            <el-row :gutter="20" v-if="detailForm.dev_inform_evt">
              <el-col :span="12">
                <el-form-item label="资产码" prop="dev_inform_evt_asset_code">
                  <el-input v-model="detailForm.dev_inform_evt.asset_code" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="版本" prop="dev_inform_evt_version">
                  <el-input v-model="detailForm.dev_inform_evt.version" readonly disabled />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-else>
              <el-col :span="24"><div class="zanwu">--暂无--</div></el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 功率曲线组件 -->
    <power-curve :show.sync="visible.curve" :params="modelParams" @confirm="confirmpowercurve" class="detail-dialog"></power-curve>
    <power-order-curve :show.sync="visible.ordercurve" :params="modelParams" @confirm="confirmpowercurve" class="detail-dialog"></power-order-curve>

    <tripletDetail ref="tripletDetail"></tripletDetail>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { getOnlinePageList, GetDevExtInfo, GetOnlineStatistic } from "@/api/dev_archive"
import { Send_DevRestart, Send_QuerySim, Send_TimeSync } from "@/api/dev_send_order"
import powercurve from "./components/power-curve.vue"
import powerordercurve from "./components/power-order-curve.vue"
import tripletDetail from "../control/_triplet_detail.vue"
import { mapGetters } from "vuex"

export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: {
    "power-order-curve": powerordercurve,
    "power-curve": powercurve,
    fileUpload,
    tripletDetail
  },
  data() {
    return {
      tableData: [],
      visible: {
        curve: false,
        ordercurve: false
      },
      filter: {
        assets_code: "",
        dev_type: "",
        online: ""
      },
      loading: false,
      isUpdate: true,
      gid: "",
      detailVisible: false,
      modelParams: {},
      detailForm: {
        // 基本档案信息
        ID: "",
        triplet: {},
        firmware_evt: {},
        acDeRealIty: {},
        verinfo_evt: {},
        dev_inform_evt: {},
        status: 0,
        re_dev_type: "",
        dev_type: 0
      },
      statistic: {
        total_power: 0,
        charging_pile: 0
      },
      tableForm: {
        deviceid: ""
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    // 总功率（接口返回单位为 0.01kW，此处换算为 kW）
    totalPowerText() {
      const power = Number(this.statistic && this.statistic.total_power)
      return isNaN(power) ? "0.00" : (power / 100).toFixed(2)
    },
    // 充电中枪数
    chargingPileText() {
      const count = Number(this.statistic && this.statistic.charging_pile)
      return isNaN(count) ? 0 : count
    }
  },
  created() {
    this.getData()
  },
  methods: {
    showTripletDetail(assetsCode) {
      this.$refs.tripletDetail.showTripletInfo(assetsCode)
    },
    onCallOfflineOrder(data) {
      // TODO: 分支箱已删除，需要确认新的API调用
    },
    onTimeSync(row) {
      Send_TimeSync({ triplet_id: row.triplet_id }).then((res) => {
        this.$message.success(res.msg)
      })
    },
    // 格式化网络类型（10-17）
    formatNetType(value) {
      if (value === null || value === undefined || value === "") return ""
      const map = {
        10: "获取不到网络类型",
        11: "2G",
        12: "3G",
        13: "4G",
        14: "5G",
        15: "NB-IOT",
        16: "WIFI",
        17: "有线网络"
      }
      const key = String(value)
      return map[key] || value
    },
    // 格式化设备注册方式（10-16）
    formatDevRegMethod(value) {
      if (value === null || value === undefined || value === "") return ""
      const map = {
        10: "屏幕",
        11: "蓝牙",
        12: "串口",
        13: "NFC",
        14: "USB 外设",
        15: "固件",
        16: "其他"
      }
      const key = String(value)
      return map[key] || value
    },
    // 格式化门锁状态（10:解锁, 11:上锁）
    formatGateLockStatus(value) {
      if (value === null || value === undefined || value === "") return ""
      const map = {
        10: "解锁",
        11: "上锁"
      }
      const key = String(value)
      return map[key] || value
    },
    // 格式化地锁状态（10:解锁状态, 11:上锁状态）
    formatGroundLockStatus(value) {
      if (value === null || value === undefined || value === "") return ""
      const map = {
        10: "解锁",
        11: "上锁"
      }
      const key = String(value)
      return map[key] || value
    },
    toFilter() {
      this.pageParams.page = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageParams.limit = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.pageParams.page = val
      this.getData()
    },

    onDevRestart(row) {
      Send_DevRestart({ triplet_id: row.triplet_id }).then((res) => {
        this.$message.success(res.msg)
      })
    },

    // 打开详情弹窗
    async onDetail(row) {
      this.detailVisible = true
      this.loading = true
      // 调用GetDevExtInfo接口获取详细数据
      const res = await GetDevExtInfo({
        asset_code: row.asset_code
      })
      this.loading = false
      if (res) {
        const data = res
        this.detailForm = data
        this.detailForm.status = row.status
        this.detailForm.re_dev_type = row.re_dev_type
        this.detailForm.triplet_id = row.triplet_id
        this.detailForm.dev_type = row.dev_type
      }
    },

    editPowerCurve(row) {
      this.modelParams = {
        asset_code: row.asset_code,
        re_dev_name: row.re_dev_name,
        re_dev_type: row.re_dev_type,
        status_name: row.status_name
      }
      if (row.re_dev_type == "充电桩") {
        this.visible.ordercurve = true
      } else {
        this.visible.curve = true
      }
    },

    confirmpowercurve(item) {
      this.visible.curve = false
      this.detailForm.asset_code = item.asset_code
    },

    getDataParams() {
      return {
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        assets_code: this.filter.assets_code || null,
        dev_type: this.filter.dev_type || null,
        online: this.filter.online || null
      }
    },

    getData() {
      this.loading = true
      var reqParams = this.getDataParams()
      getOnlinePageList(reqParams)
        .then((res) => {
          this.tableData = res.data
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
      GetOnlineStatistic(reqParams)
        .then((res) => {
          this.statistic = (res && res.outputData) || { total_power: 0, charging_pile: 0 }
        })
        .catch(() => {
          this.statistic = { total_power: 0, charging_pile: 0 }
        })
    },
    onSendQuerySim(row) {
      this.loading = true
      Send_QuerySim({ triplet_id: row.triplet.ID }).then((res) => {
        this.$message.success(res.msg)
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
/* 页面整体：纵向自适应填充，内容区内部滚动 */
.app-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 顶部工具栏：左侧筛选条件，右侧统计数据 */
.page-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-shrink: 0;
  margin-bottom: 12px;
}

.filter-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.filter-form ::v-deep .el-form-item {
  margin-right: 16px;
  margin-bottom: 8px;
}

/* ---------- 统计卡片 ---------- */
.stat-group {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.stat-card {
  display: flex;
  align-items: center;
  min-width: 150px;
  padding: 8px 16px;
  margin-left: 12px;
  background: #f7f9fc;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.stat-card:hover {
  border-color: #c6d4e8;
  box-shadow: 0 2px 10px rgba(64, 128, 255, 0.12);
}

.stat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  margin-right: 10px;
  border-radius: 8px;
  font-size: 18px;
  color: #fff;
}

.stat-icon-power {
  background: linear-gradient(135deg, #ffbb66, #fa8c16);
}

.stat-icon-charging {
  background: linear-gradient(135deg, #6ee7c6, #13c2a3);
}

.stat-info {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.stat-label {
  font-size: 12px;
  color: #909399;
}

.stat-value {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  font-variant-numeric: tabular-nums;
}

.stat-unit {
  margin-left: 2px;
  font-size: 12px;
  font-weight: 400;
  color: #909399;
}

/* ---------- 表格区域：占满剩余高度 ---------- */
.box-card {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.box-card ::v-deep .el-card__body {
  flex: 1;
  min-height: 0;
  padding: 0;
  overflow: hidden;
}

.my-pagination {
  flex-shrink: 0;
  margin-top: 12px;
  text-align: right;
}

/* ---------- 详情弹窗 ---------- */
.detail-dialog ::v-deep .el-dialog {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.detail-dialog .el-row {
  margin-bottom: 16px;
}

.detail-dialog .el-row:last-child {
  margin-bottom: 0;
}

.detail-dialog .el-col {
  border-radius: 4px;
}

.zanwu {
  line-height: 50px;
  text-align: center;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

/* 窄屏适配：统计卡片换行后独占一行 */
@media screen and (max-width: 1280px) {
  .stat-group {
    width: 100%;
    margin-left: 0;
    margin-top: 12px;
  }

  .stat-card:first-child {
    margin-left: 0;
  }
}
</style>
